import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Nav,
  Navbar,
} from "react-bootstrap";
import TopNavBar from "./TopNavBar";
import logoImg from '../../logo.png'
import { Link } from "react-router-dom";

const SideBar = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true); // Start with the sidebar closed
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const mainContentClassName = `main-content ${sidebarOpen ? "" : " closed"}`;
  const handleLogout = () => {
    sessionStorage.removeItem('sakhi_token_admin');
    sessionStorage.removeItem('sakhi_token_data_admin');
    window.location.href = '/admin';
  };


  return (
    <Container fluid>
      <Row>
        <Col md={2} className={`sidebar ${sidebarOpen ? " open" : ""}`}>
          <div className="position-sticky">
            <Nav defaultActiveKey="/home" className="flex-column text-white">
              <Nav.Item
                href="#"
                className=" "
              >
                <div className="text-center">
                  <h5>Sakhi Desinger</h5>
                </div>
                <div className="mobile-toggle  position-absolute top-0 end-0 text-white float-right">
                  <button
                    onClick={toggleSidebar}
                    type="button"
                    className="btn-close text-white float-right"
                    aria-label="Close"
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>


              </Nav.Item >
              <div style={{ margin: "13px 0", border: "0.1px solid #8080804f" }}></div>
              <Nav.Item className="py-2 px-2 mt-1">
                <Link className="text-white py-2" to="/admin/dashboard"><i className="fa fa-tachometer" aria-hidden="true"></i>&nbsp; Dashboard</Link>
              </Nav.Item >
              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin/category"><i className="fa fa-th-large" aria-hidden="true"></i>&nbsp; Category</Link>
              </Nav.Item>

              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin/sub-category"><i className="fa fa-th" aria-hidden="true"></i>&nbsp; Sub Category</Link>
              </Nav.Item >
              {/* <Nav.Item className="py-2 px-2">
                <Link className="text-white " to="/admin/gst"><i className="fa fa-list" aria-hidden="true"></i>&nbsp; GST List</Link>
              </Nav.Item > */}

              {/* <Nav.Item className="py-2 px-2">
                <Link className="text-white " to="/admin/size"><i className="fa fa-list" aria-hidden="true"></i>&nbsp; Size List</Link>
              </Nav.Item > */}

              <Nav.Item className="py-2 px-2">
                <Link className="text-white " to="/admin/attributes"><i className="fa fa-list" aria-hidden="true"></i>&nbsp; Attributes</Link>
              </Nav.Item >

              <Nav.Item className="py-2 px-2"
              >
                <Link className="text-white py-2" to="/admin/sub-category-attribute-group"><i className="fa fa-cubes" aria-hidden="true"></i>&nbsp;
                  Sub-Category Attribute Group</Link>

              </Nav.Item >
              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin/products"><i className="fa fa-shopping-basket" aria-hidden="true"></i>&nbsp; Products</Link>
              </Nav.Item >

              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin/2/orders"><i className="fa fa-university" aria-hidden="true"></i>&nbsp; Orders</Link>
              </Nav.Item >


              

              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin/contact-list"><i className="fa fa-address-card" aria-hidden="true"></i>&nbsp;
                  Contact Us</Link>
              </Nav.Item >

              <hr />
              <Nav.Item className="py-2 px-2">
                <Link className="text-white py-2" to="/admin" onClick={handleLogout}><i className="fa fa-sign-out" aria-hidden="true"></i>&nbsp;
                  Log Out
                </Link>
              </Nav.Item >

            </Nav>
          </div>
        </Col>

        <Col md={sidebarOpen ? 10 : 12} className={mainContentClassName}>
          <Navbar expand="lg" style={{ backgroundColor: "#ede9e9" }}>
            <Navbar.Text href="#">
              {" "}
              <button onClick={toggleSidebar} className="btn btn-light mx-3 ">
                ☰
              </button>{" "}
            </Navbar.Text>
            <Navbar.Brand
              className="d-inline-block align-top"
              style={{ lineHeight: "2.0" }}
            >
              {/* <img
                alt=""
                src={logoImg}
                width="40"
                height="40"
                className="d-inline-block align-top mx-3"
              /> */}


            </Navbar.Brand>

            <Navbar.Text href="#home"> </Navbar.Text>
            {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}
            <Navbar.Collapse id="navbarScroll"></Navbar.Collapse>
          </Navbar>
          <main>{children}</main>
        </Col>
      </Row>
    </Container>
  );
};

export default SideBar;
